<template>
  <div class="webinar-status is-upcoming">
    <div class="status-box">
      <h2>{{ $t('thanks_for_registering') }}</h2>
      <h3>{{ $t('confirmation_mail_sent') }}</h3>
      <p style="font-size:16px;">{{ $t('join_15_min_before') }}</p>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  data() {},
  computed: {},
  methods: {}
};
</script>
<style lang="less">
.webinar-status {
  height: 100vh;
  padding: 64px 16px 16px 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  color: #272727;
  line-height: 1.2;
  .status-box {
    width: 100%;
    max-width: 720px;
    padding: 48px 16px;
    background: #fff;
    text-align: center;
    .timer {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 48px;
      &--item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 0 12px;
        &__desc {
          font-weight: 500;
          font-size: 14px;
          color: #999999;
        }
        &__time {
          font-weight: 500;
          font-size: 56px;
          color: #000000;
          line-height: 1;
          @media (max-width: 575px) {
            font-size: 32px;
          }
        }
      }
    }
    h2 {
      font-weight: 600;
      font-size: 32px;
      margin: 0;
      @media (max-width: 575px) {
        font-size: 24px;
      }
    }
    h3 {
      font-weight: 500;
      font-size: 18px;
      margin: 8px 0 0 0;
      @media (max-width: 575px) {
        font-size: 16px;
      }
    }
    p {
      font-weight: 500;
      font-size: 12px;
      color: #999999;
      margin: 8px 0 0 0;
    }
  }
  &.is-ended {
    .status-box {
      padding: 96px 16px;
    }
  }
}
</style>
